import { Loader2 } from "lucide-react";

import { ButtonShadcn } from "@/components/ui/Button";

// Shared by BrandingActionBar (the page-level actions) and BrandingForm (the
// Save Draft/Discard Changes pair scoped to just its own fields) — one
// button shape for every in-flight action on this page, instead of each
// section forking its own.
const BrandingActionButton = ({ children, loadingText, onClick, disabled, loading, variant }) => (
  // `size="sm"` rounds itself via `var(--radius-md)`, a custom property this
  // app never defines (only `--radius` exists) — the arbitrary value goes
  // invalid and the button renders with square corners. `rounded-lg` here
  // overrides it back to the working token (tailwind-merge keeps the last
  // radius class), without touching the shared Button.jsx.
  <ButtonShadcn
    type="button"
    variant={variant}
    size="sm"
    onClick={onClick}
    disabled={disabled || loading}
    className="rounded-lg"
  >
    {loading && <Loader2 size={12} className="animate-spin" />}
    {loading ? loadingText : children}
  </ButtonShadcn>
);

export default BrandingActionButton;
